import type { AbTestingClientInstance } from "@/client/instance.ts";

import { getSentryAbTesting } from "@/client/sentry.ts";

type FeatureGates = {
  domReady: Promise<void>;
  navigationReady: Promise<void>;
};

type ClientFeature = (
  instance: AbTestingClientInstance,
  gates: FeatureGates,
) => Promise<void>;

// One throwing factory must not take the rest of the page's tests down with it.
async function runFeatures(
  instance: AbTestingClientInstance,
  factories: readonly (() => ClientFeature)[],
  {
    domReady = Promise.resolve(),
    navigationReady = Promise.resolve(),
  }: Partial<FeatureGates> = {},
): Promise<void> {
  const results = await Promise.allSettled(
    factories.map(async (factory) =>
      factory()(instance, { domReady, navigationReady }),
    ),
  );

  results.forEach((result) => {
    if (result.status === "rejected") {
      getSentryAbTesting().captureException(result.reason);
    }
  });
}

export type { ClientFeature, FeatureGates };
export { runFeatures };
